module.exports = __webpack_public_path__ + "js.jpg?ecdd3ee75ea059809bccedb140814759";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/js.jpg
// module id = 53
// module chunks = 0